import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class TarefaAgendadaModel extends EntidadeBase {
    constructor() {
        super('tarefaagendada');
    }

    async ativar(id) { return await ApiService.post('tarefaagendada/ativar', { id }); }
    async desativar(id) { return await ApiService.post('tarefaagendada/desativar', { id }); }
    async executarAgora(id) { return await ApiService.post('tarefaagendada/executaragora', { id }); }
}
const instance = new TarefaAgendadaModel();
export default instance;
